// extracted by mini-css-extract-plugin
export default {"logo":"logo-module_logo-CCG1X"};